import React from 'react';
import './index.scss';
import {List, ListItem, ListItemText, ListItemSecondaryAction, Paper, IconButton } from '@material-ui/core';
import uuid from 'uuid4'

import Icon from '@mdi/react'
import { mdiInformation} from '@mdi/js'
import { inject } from 'mobx-react';

@inject("translate")
@inject("internal")
export default class RightBox extends React.Component {

    showProductDetail = (url) => {
        this.props.internal.pushRoute(url);
    }

    render() {
        
        return (
            <div>
                {this.props.admin ? null :
                <p className={'list-title'}>{this.props.translate.i18n.MODULES.DASHBOARD.LAST_ORDERED_PRODUCTS}</p>
                }
            <Paper >
                <List className={`list ${this.props.countsForClient ? 'client-counts': ''}`} >
                    {this.props.children.map((data, index) => {
                        return (
                            <ListItem key={uuid()} className={'list-item'}>
                                <ListItemText primary={data.title} secondary={this.props.admin ? null:data.subtitle} className={'list-item-text'}/>
                                
                                    {this.props.admin ?
                                        data.url ?
                                            <span className={`count ${data.url ? "link": ""} `} onClick={() =>this.showProductDetail(data.url)}>{data.count} </span>
                                            :
                                            <span className={`count ${data.url ? "link": ""} `}>{data.count}</span>
                                        :
                                        <ListItemSecondaryAction>
                                            <IconButton aria-label="detail" className={'icon-btn'} onClick={() =>this.showProductDetail(data.url)}>
                                                <Icon path={mdiInformation} size={1}  className={'icon-detail'} />
                                            </IconButton>
                                        </ListItemSecondaryAction>
                                    }
                                
                            </ListItem>
                        );
                    })}
                </List>
            </Paper>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/basic/rightBox/index.js